import { render, staticRenderFns } from "./BAutocompletePassportList.vue?vue&type=template&id=64bbf56a&"
import script from "./BAutocompletePassportList.vue?vue&type=script&lang=js&"
export * from "./BAutocompletePassportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports